<template>
  <div class="app-container">
    <el-button
      type="primary"
      @click="addMenu(0)"
      style="margin-bottom: 5px"
      v-if="roles.includes('/hire/add_house')"
      >添加</el-button
    >
    <el-button
      type="primary"
      plain
      @click="reset()"
      style="margin-bottom: 5px; float: right"
      >重置</el-button
    >
    <el-button
      type="primary"
      @click="(screen.page = 1), fetchData()"
      style="margin-bottom: 5px; float: right"
      >搜索</el-button
    >
    <el-select
      filterable
      style="float: right"
      v-model="screen.type_id"
      placeholder="请选择类型"
    >
      <el-option label="全部" value="0"></el-option>
      <el-option
        :label="item.title"
        :value="item.id"
        v-for="(item, index) in typeList"
        :key="index"
      ></el-option>
    </el-select>
    <el-select
      filterable
      style="float: right; margin-right: 10px"
      v-model="screen.park_id"
      placeholder="请选择园区"
      :disabled="userInfo.park_id != 0"
      @change="parkChange"
    >
      <el-option label="全部" value="0"></el-option>
      <el-option
        :label="item.name"
        :value="item.id"
        v-for="(item, index) in parkList"
        :key="index"
      ></el-option>
    </el-select>
    <el-table
      max-height="700"  v-loading="listLoading" 
      :header-cell-style="{ background: '#F2F3F5', color: '#606266' }"
      :data="list"
      element-loading-text="Loading"
      fit
      highlight-current-row
      stripe
      class="table-box"
      tooltip-effect="dark"
      row-key="id"
      :tree-props="{ children: 'nodes', hasChildren: 'hasChildren' }"
    >
      <el-table-column align="center" label="序号" width="95">
        <template slot-scope="scope">
          <!-- {{ scope.$index + 1 }} -->
          {{ (screen.page - 1) * screen.page_size + scope.$index + 1 }}
        </template>
      </el-table-column>
      <el-table-column prop="id" label="ID" width="100"> </el-table-column>
      <el-table-column label="类型">
        <template slot-scope="scope">
          <span>{{ scope.row.type.title }}</span>
        </template>
      </el-table-column>
      <el-table-column label="园区" min-width="150">
        <template slot-scope="scope">
          <span>{{ scope.row.park_name }}</span>
        </template>
      </el-table-column>
      <el-table-column label="标题" min-width="210">
        <template slot-scope="scope">
          <span>{{ scope.row.title }}</span>
        </template>
      </el-table-column>
      <el-table-column label="地点" min-width="110">
        <template slot-scope="scope">
          <span>{{ scope.row.address }}</span>
        </template>
      </el-table-column>
      <el-table-column label="楼号">
        <template slot-scope="scope">
          <span>{{ scope.row.building }}</span>
        </template>
      </el-table-column>
      <el-table-column label="单价">
        <template slot-scope="scope">
          {{ scope.row.price }}
        </template>
      </el-table-column>
      <el-table-column label="状态" min-width="110" align="center">
        <template slot-scope="scope">
          <el-tag
            :type="scope.row.status == '1' ? 'success' : 'danger'"
            disable-transitions
            >{{ scope.row.status == 1 ? "启用" : "禁用" }}</el-tag
          >
        </template>
      </el-table-column>
      <el-table-column prop="created_at" label="操作" width="260" fixed="right">
        <template slot-scope="scope">
          <el-button
            size="mini"
            type="success"
            @click="handleEdit(scope.row)"
            v-if="roles.includes('/hire/edit_house')"
            >编辑</el-button
          >
          <el-button
            size="mini"
            type="danger"
            @click="handleDelete(scope.row.id)"
            v-if="roles.includes('/hire/house_del')"
            >删除</el-button
          >
          <!-- <el-button
            size="mini"
            type="success"
            @click="getRegisterUser(scope.row.id)"
            v-if="roles.includes('/hire/intention_user')"
            >意向用户列表</el-button
          > -->
        </template>
      </el-table-column>
    </el-table>
    <el-pagination
      @size-change="handleSizeChange"
      @current-change="handleCurrentChange"
      :current-page="screen.page"
      :page-sizes="[15, 30, 50]"
      :page-size="screen.page_size"
      layout="total, sizes, prev, pager, next, jumper"
      :total="total"
      style="margin-top: 10px"
    >
    </el-pagination>
    <el-drawer
      size="800px"
      :title="drawerTitle"
      :visible.sync="drawer"
      direction="rtl"
      :before-close="handleClose"
    >
      <el-form
        :model="ruleForm"
        :rules="rules"
        ref="ruleForm"
        label-width="120px"
        class="demo-ruleForm"
      >
        <el-form-item label="选择园区" prop="park_id">
          <el-select
            filterable
            v-model="ruleForm.park_id"
            placeholder="请选择园区"
            :disabled="cztype == 'see' || userInfo.park_id != 0"
            @change="formParkChange"
          >
            <el-option
              :label="item.name"
              :value="item.id"
              v-for="(item, index) in parkList"
              :key="index"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="选择类型" prop="type_id">
          <el-select
            filterable
            v-model="ruleForm.type_id"
            placeholder="请选择房屋类型"
            :disabled="cztype == 'see'"
          >
            <el-option
              :label="item.title"
              :value="item.id"
              v-for="(item, index) in formTypeList"
              :key="index"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="标题" prop="title">
          <el-input
            class="w4"
            v-model="ruleForm.title"
            placeholder="请输入标题"
          ></el-input>
        </el-form-item>
        <el-form-item label="房屋图片" prop="thumb">
          <el-upload
            name="file[]"
            :data="{ type: 'image' }"
            class="avatar-uploaders1"
            :action="ossUpload"
            accept="image/*"
            :headers="{ token: token }"
            list-type="picture-card"
            :show-file-list="true"
            :file-list="fileList"
            :on-remove="handleRemovePic"
            :on-success="handleAvatarSuccess"
            :disabled="cztype == 'see'"
          >
            <!-- <img
              v-if="ruleForm.thumb"
              :src="imageUrl + ruleForm.thumb"
              class="avatar-uploaders"
            /> -->
            <i class="el-icon-plus avatar-uploader-icon"></i> </el-upload
          ><!-- 已修改 -->
        </el-form-item>
        <el-form-item label="房屋视频" prop="video">
          <el-upload
            name="file[]"
            :data="{ type: 'video' }"
            :action="ossUpload"
            :headers="{ token: token }"
            accept="video/mp4"
            list-type="picture-card"
            :show-file-list="false"
            :on-error="videoErr"
            :on-progress="videoProgross"
            :on-success="handleVideoSuccess"
            :disabled="cztype == 'see'"
          >
            <el-progress
              v-if="percentage != 0 && percentageShow"
              type="circle"
              :percentage="percentage"
            ></el-progress>
            <div class="video-box" v-if="ruleForm.video">
              <div class="handles">
                <i class="el-icon-delete" @click.stop="delVideo"></i>
              </div>
              <video controls :src="imageOss + ruleForm.video" />
            </div>
            <i class="el-icon-plus avatar-uploader-icon" v-else></i>
            <div slot="tip" class="el-upload__tip">
              只能上传mp4文件
            </div> </el-upload
          ><!-- 已修改 -->
        </el-form-item>
        <el-form-item label="房屋地址" prop="address">
          <el-input
            type="textarea"
            :rows="2"
            class="w4"
            v-model="ruleForm.address"
            placeholder="请输入房屋地址"
          ></el-input>
        </el-form-item>
        <el-form-item label="房屋楼号" prop="building">
          <el-input
            class="w4"
            v-model="ruleForm.building"
            placeholder="请输入房屋楼号"
          ></el-input>
        </el-form-item>
        <el-form-item label="房屋面积" prop="area">
          <el-input
            class="w4"
            type="number numInput"
            v-model="ruleForm.area"
            placeholder="请输入房屋面积"
            ><template slot="append">㎡</template></el-input
          >
        </el-form-item>
        <el-form-item label="房屋单价" prop="price">
          <el-input
            class="w4 numInput"
            type="number"
            v-model="ruleForm.price"
            placeholder="请输入房屋单价"
            ><template slot="append">元/㎡</template></el-input
          >
        </el-form-item>
        <el-form-item label="状态" prop="status">
          <el-radio-group v-model="ruleForm.status" :disabled="cztype == 'see'">
            <el-radio :label="1">启用</el-radio>
            <el-radio :label="2">禁用</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="联系电话" prop="contact_phone">
          <el-input
          maxlength="11"
            class="w4 numInput"
            type="number"
            v-model="ruleForm.contact_phone"
            placeholder="请输入联系电话"
          ></el-input>
        </el-form-item>
        <el-form-item label="排序" prop="sort">
          <el-input
            class="w4 numInput"
            v-model="ruleForm.sort"
            placeholder="请输入排序"
            type="number"
          ></el-input>
        </el-form-item>
        <el-form-item label="房屋详情" prop="content">
          <Editor
            ref="myQuillEditor"
            style="width: 100%"
            v-model="ruleForm.content"
          />
        </el-form-item>
        <el-form-item>
          <el-button
            v-if="cztype == 'add'"
            type="primary"
            @click="submitForm('ruleForm')"
          >
            立即创建
          </el-button>
          <el-button
            v-if="cztype == 'edit'"
            type="primary"
            @click="editForm('ruleForm')"
          >
            修改
          </el-button>
          <el-button
            v-if="cztype == 'edit'"
            type="info"
            @click="drawer = false"
          >
            取消
          </el-button>
          <el-button
            v-if="cztype == 'add'"
            type="info"
            @click="resetForm('ruleForm')"
            >取消</el-button
          >
        </el-form-item>
      </el-form>
    </el-drawer>
    <el-dialog title="意向用户列表" :visible.sync="dialogVisible" width="60%">
      <el-table
        v-loading="userLoading"
        :data="registerUserList"
        :header-cell-style="{ background: '#F2F3F5', color: '#606266' }"
        element-loading-text="Loading"
        fit
        highlight-current-row
        stripe
        class="table-box"
        tooltip-effect="dark"
        row-key="id"
      >
        <el-table-column align="center" label="序号" width="95">
          <template slot-scope="scope">
            <!-- {{ scope.$index + 1 }} -->
            {{
              (registerUser.page - 1) * registerUser.page_size +
              scope.$index +
              1
            }}
          </template>
        </el-table-column>
        <el-table-column label="房屋名称">
          <template slot-scope="scope">
            <div class="line2" v-if="scope.row.house">
              {{ scope.row.house.title }}
            </div>
          </template>
        </el-table-column>
        <el-table-column label="姓名">
          <template slot-scope="scope">
            <span>{{ scope.row.user_name }}</span>
          </template>
        </el-table-column>
        <el-table-column label="手机号">
          <template slot-scope="scope">
            <span>{{ scope.row.phone }}</span>
          </template>
        </el-table-column>
        <el-table-column label="申请时间">
          <template slot-scope="scope">
            <span>{{ scope.row.create_time }}</span>
          </template>
        </el-table-column>
      </el-table>
      <span slot="footer" class="dialog-footer">
        <el-pagination
          :page-size="registerUser.page_size"
          @current-change="registerPageChange"
          layout="prev, pager, next"
          :current-page="registerUser.page"
          :total="registerUser.total"
        >
        </el-pagination>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import Editor from "@/components/Editor";
import { housing_type } from "@/api/common";
import { openPark, delImage } from "@/api/index";
import {
  add_house,
  edit_house,
  house_list,
  house_del,
  house_info,
  intention_user,
} from "@/api/lease";
import { getToken } from "@/utils/auth";
export default {
  components: { Editor },
  computed: {
    ...mapGetters(["roles", "userInfo", "imageUrl", "imageOss"]),
  },
  data() {
    return {
      dialogVisible: false,
      userLoading: true,
      token: getToken(),
      list: [],
      listLoading: true,
      drawer: false,
      drawerTitle: "添加",
      screen: {
        page: 1,
        page_size: 15,
        park_id: "",
        type_id: "",
        title: "",
      },
      typeList: [],
      total: 0,
      ruleForm: {},
      fileList: [],
      rules: {
        park_id: [{ required: true, message: "请选择园区", trigger: "change" }],
        type_id: [
          { required: true, message: "请选择房屋类型", trigger: "change" },
        ],
        thumb: [{ required: true, message: "请选择房屋图片" }],
        status: [{ required: true, message: "请选择状态" }],
        sort: [{ required: true, message: "请输入排序", trigger: "blur" }],
        title: [{ required: true, message: "请输入标题", trigger: "blur" }],
        content: [
          { required: true, message: "请输入房间内容", trigger: "blur" },
        ],
        address: [
          { required: true, message: "请输入房屋地址", trigger: "blur" },
        ],
        building: [
          { required: true, message: "请输入房屋楼号", trigger: "blur" },
        ],
        area: [{ required: true, message: "请输入房屋面积", trigger: "blur" }],
        price: [{ required: true, message: "请输入房屋单价", trigger: "blur" }],
        // video: [{ required: true, message: "请选择房屋视频", trigger: "blur" }],
        contact_phone: [
          { required: true, message: "请输入联系电话", trigger: "blur" },
        ],
      },
      cztype: "",
      ossUpload: this.$store.state.ossUpload,
      parkList: [],
      clearPics: [],
      registerUser: {
        id: "",
        page: 1,
        page_size: 15,
        total: 0,
      },
      registerUserList: [],
      formTypeList: [],
      percentage: 0,
      percentageShow: true,
      clearVideos: [],
    };
  },
  created() {
    if (this.userInfo.park_id !== 0) {
      this.screen.park_id = this.userInfo.park_id;
    } else {
      this.screen.park_id = "";
    }
    this.fetchData();
    this.getPark();
    this.getTypes();
  },
  methods: {
    parkChange(e) {
      this.screen.type_id = "";
      this.getTypes();
    },
    formParkChange() {
      this.getTypes("form");
      this.ruleForm.type_id = "";
    },
    getTypes(from) {
      var data = {
        park_id: "",
        status: 1,
        is_page: 2,
      };
      if (from == "form") {
        data.park_id = this.ruleForm.park_id;
        housing_type(data).then((res) => {
          this.formTypeList = res.data.lists;
        });
      } else {
        data.park_id = this.screen.park_id;
        housing_type(data).then((res) => {
          this.typeList = res.data.lists;
        });
      }
    },
    delVideo() {
      this.clearVideos.push(this.ruleForm.video);
      this.ruleForm.video = "";
    },
    videoProgross(e) {
      this.percentage = parseInt(e.percent);
    },
    handleVideoSuccess(res, file, fileList) {
      this.percentageShow = false;
      if (res.code === 200) {
        this.ruleForm.video = res.data.url;
      } else {
        this.$message.error("上传失败，" + res.msg);
      }
    },
    videoErr() {
      this.$message.error("上传失败");
    },
    handleRemovePic(file, fileList) {
      if (file.response.data.url) {
        this.clearPics.push(file.response.data.url);
      }
      var list = [];
      list = fileList.map((item) => {
        return item.response.data.url;
      });
      this.ruleForm.thumb = list.join(",");
    },
    delImges() {
      if (this.clearPics.length) {
        delImage({ file: this.clearPics.join(",") }).then((ress) => {});
      }
      if (this.clearVideos.length) {
        delImage({ file: this.clearVideos.join(",") }).then((ress) => {});
      }
    },
    handleAvatarSuccess(res, file, fileList) {
      if (res.code === 200) {
        var list = [];
        list = fileList.map((item) => {
          return item.response.data.url;
        });
        this.ruleForm.thumb = list.join(",");
      } else {
        this.$message({
          message: res.msg,
          type: "error",
        });
        var list = [];
        fileList.map((item) => {
          if (item.response.code == 200) {
            list.push({
              name: +new Date(),
              url: imageOss + item.response.data.url,
              response: {
                data: {
                  url: item.response.data.url,
                },
              },
            });
          }
        });
        this.fileList = list;
      }
      // this.ruleForm.icon = URL.createObjectURL(file.raw)
    },
    reset() {
      this.screen = {
        park_id: "",
        title: "",
        type_id: "",
        page: 1,
        page_size: 15,
      };
      if (this.userInfo.park_id !== 0) {
        this.screen.park_id = this.userInfo.park_id;
      } else {
        this.screen.park_id = "";
      }
      this.fetchData();
      this.getTypes();
    },
    handleSizeChange(val) {
      this.screen.page_size = val;
      this.screen.page = 1;
      this.fetchData();
    },
    handleCurrentChange(val) {
      this.screen.page = val;
      this.fetchData();
    },
    // 修改
    editForm(formName) {
      var that = this;
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.$confirm("确认提交？")
            .then(() => {
              edit_house(that.ruleForm).then((res) => {
                if (res.code === 200) {
                  this.$message({
                message: res.msg,
                type: "success",
              });
                  that.delImges();
                  that.drawer = false;
                  that.fetchData();
                }
              });
            })
            .catch(() => {});
        } else {
          this.$nextTick(() => {
            that.elFormErrorScrollIntoView();
          });

          return false;
        }
      });
    },
    // 编辑
    handleEdit(val) {
      this.cztype = "edit";
      this.drawerTitle = "编辑";
      this.clearPics = [];
      this.fileList = [];
      this.clearVideos = [];
      this.getInfo(val.id);
      // this.drawer = true;
    },
    registerPageChange(current) {
      this.registerUser.page = current;
      this.getRegisteredList();
    },
    getRegisterUser(house_id) {
      this.userLoading = true;
      this.registerUser = {
        house_id,
        page: 1,
        page_size: 15,
        total: 0,
      };
      this.getRegisteredList();
    },
    getRegisteredList() {
      intention_user(this.registerUser).then((res) => {
        this.userLoading = false;
        this.dialogVisible = true;
        this.registerUserList = res.data.lists.data;
        this.registerUser.page = res.data.lists.current_page;
        this.registerUser.total = res.data.lists.total;
      });
    },
    // 查看
    handleSee(val) {
      this.cztype = "see";
      this.drawerTitle = "查看";
      // this.ruleForm = val
      this.getInfo(val.id);
      // this.drawer = true;
    },
    // 获取信息
    getInfo(id) {
      var that = this;
      house_info({ id: id }).then((res) => {
        // this.domains = res.data.company_role_data
        that.ruleForm = {
          id: res.data.info.id,
          park_id: res.data.info.park_id,
          thumb: res.data.info.thumb,
          video: res.data.info.video,
          status: res.data.info.status,
          sort: res.data.info.sort,
          title: res.data.info.title,
          content: res.data.info.content,
          address: res.data.info.address,
          building: res.data.info.building,
          type_id: res.data.info.type_id,
          area: res.data.info.area ? Number(res.data.info.area) : 0,
          price: res.data.info.price ? Number(res.data.info.price) : 0,
          contact_phone: res.data.info.contact_phone
            ? Number(res.data.info.contact_phone)
            : null,
        };
        this.getTypes("form");
        var list = res.data.info.thumb.split(",");
        this.fileList = list.map((item) => {
          return {
            name: +new Date(),
            url: this.imageOss + item,
            response: {
              data: {
                url: item,
              },
            },
          };
        });
      });
      this.drawer = true;
    },
    // 删除
    handleDelete(id) {
      var that = this;
      this.$confirm("确认删除？")
        .then(() => {
          house_del({ id: id }).then((res) => {
            if (res.code == 200) {
              this.$message({
                message: "删除成功",
                type: "success",
              });
            }
            that.fetchData();
          });
        })
        .catch(() => {});
    },
    submitForm(formName) {
      var that = this;
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.$confirm("确认提交？")
            .then(() => {
              add_house(that.ruleForm).then((res) => {
                if (res.code === 200) {
                  this.$message({
                message: res.msg,
                type: "success",
              });
                  that.delImges();
                  that.drawer = false;
                  that.fetchData();
                }
              });
            })
            .catch(() => {});
        } else {
          this.$nextTick(() => {
            that.elFormErrorScrollIntoView();
          });

          return false;
        }
      });
    },
    handleClose(done) {
      this.$confirm("确认关闭？")
        .then(() => {
          this.$nextTick(() => {
            this.$refs.ruleForm.clearValidate();
          });
          done();
        })
        .catch(() => {});
    },
    addMenu(id) {
      this.drawerTitle = "添加";
      this.cztype = "add";
      this.ruleForm = {
        park_id: "",
        thumb: "",
        status: 1,
        sort: 0,
        title: "",
        content: "",
        address: "",
        building: "",
        area: "",
        price: "",
        type_id: "",
        video: "",
      };
      this.clearPics = [];
      this.fileList = [];
      this.clearVideos = [];
      if (this.userInfo.park_id !== 0) {
        this.ruleForm.park_id = this.userInfo.park_id;
        this.getTypes("form");
      }
      this.$nextTick(() => {
        this.$refs.ruleForm.clearValidate();
      });
      this.drawer = true;
    },
    // 获取园区
    getPark() {
      this.parkList = [];
      openPark({ is_page: 2, status: 1 }).then((res) => {
        this.parkList = res.data.lists;
      });
    },
    // 重置
    resetForm(formName) {
      this.$refs.ruleForm.resetFields();
      this.drawer = false;
    },
    fetchData() {
      this.listLoading = true;
      house_list(this.screen).then((response) => {
        this.list = response.data.lists.data;
        this.total = response.data.lists.total;
        this.listLoading = false;
      });
    },
  },
};
</script>
<style lang="scss" scoped>
// .el-button {
//   color: #000 !important;
// }
::v-deep .el-drawer__body {
  padding-right: 20px;
  overflow: auto;
}
.table-box {
  margin-top: 20px;
}
.video-box {
  width: 148px;
  height: 148px;
  position: relative;
  border-radius: 6px;
  overflow: hidden;
  video {
    width: 100%;
    height: 100%;
  }
  &:hover {
    .handles {
      opacity: 1;
    }
  }
  .handles {
    position: absolute;
    width: 100%;
    height: 100%;
    left: 0;
    top: 0;
    z-index: 3;
    cursor: pointer;
    text-align: center;
    color: #fff;
    opacity: 0;
    font-size: 20px;
    background-color: rgba(0, 0, 0, 0.5);
    transition: opacity 0.3s;
    .el-icon-delete {
      font-size: 20px;
      color: #fff;
    }
  }
}
.avatar-uploaders {
  width: 80px;
  height: 80px;
  text-align: center;
  border: 1px solid #d9d9d9;
  line-height: 90px;
}
.avatar-uploader-icon {
  font-size: 28px;
  color: #8c939d;
  text-align: center;
}
.tableIcon {
  width: 50px;
  height: 50px;
}
.screenInput {
  width: 200px;
  margin: 0 10px;
}
.w4 {
  width: 40%;
}
::v-deep .el-table .el-table__body td .cell:empty::after,
.el-table .el-table__body td .cell > span:empty::after,
.el-table .el-table__body td .cell .approval:empty::after,
.el-table .el-table__body td .cell div:empty::after,
.el-table .el-table__body td .cell .line-limit-length:empty::after {
  content: "--";
}
.numInput {
  ::v-deep .el-input__inner {
    padding-right: 0 !important;
  }
}
</style>
